import { ref } from 'vue';
import { getProfile } from '@/api/profile';

export interface CurrentUser {
  userId: number | null;
  name: string;
  email: string;
}

const currentUser = ref<CurrentUser>({ userId: null, name: '', email: '' });
const avatarUrl = ref<string | null>(null);

function readFromStorage(): CurrentUser {
  try {
    const raw = localStorage.getItem('auth_user');
    if (!raw) return { userId: null, name: '', email: '' };
    const u = JSON.parse(raw) as { user_id?: number; id?: number; name?: string; email?: string };
    return { userId: u.user_id ?? u.id ?? null, name: u.name ?? '', email: u.email ?? '' };
  } catch {
    return { userId: null, name: '', email: '' };
  }
}

export async function refreshCurrentUser(): Promise<void> {
  const user = readFromStorage();
  currentUser.value = user;
  avatarUrl.value = null;
  if (!user.userId) return;
  try {
    const data = await getProfile(user.userId);
    if (data.image) avatarUrl.value = data.image;
  } catch {
    // fall back to icon
  }
}

export function resetCurrentUser(): void {
  currentUser.value = { userId: null, name: '', email: '' };
  avatarUrl.value = null;
}

export function useCurrentUser() {
  return { currentUser, avatarUrl };
}
